export const StepsModal = [
  {
    label: "Datas",
    action: "days",
  },
  {
    label: "Meses",
    action: "months",
  },
];

export const StepIndicators = [
  {
    label: "Indicadores de Desempenho",
    action: true,
  },
  {
    label: "Indicadores de Endividamento",
    action: false,
  },
];

export const StepsYesOrNot = [
  { label: "Sim", action: true },
  { label: "Não", action: false },
];

export const MonthsQuantity = Array.from({ length: 36 }, (_, i) => {
  const n = i + 1;
  return {
    value: n.toString(),
    label: `${n} ${n === 1 ? "mês" : "meses"}`,
  };
});
